import axios, { getEnv } from './api';

const dashboardService = {
  get: async (method) => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/${method}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getAcessos: async (info, filters) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/dashboards/${info}`,
        filters
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getResumo: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/dashboards/destaques`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  cleanCache: async () => {
    try {
      const res = await axios.delete(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/cache`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default dashboardService;
